import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import dayjs from 'dayjs'
import { useSelector } from 'react-redux'
import MixrCard from 'srcReact/components/common2/MixrCard'
import Modal from 'srcReact/components/common2/Modal'
import { appConstantSettings } from 'srcReact/appConstantSettings'

const MonthlyEvent = ({ event }) => {
  const { t } = useTranslation()
  const {
    common: { isMobile }
  } = useSelector((state) => state)
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <React.Fragment>
      <div className={styles.monthlyWrapper}>
        {event.attending_count >= 1 && (
          <div className={styles.attending} onClick={() => setIsModalOpen(true)}>{`${event.attending_count} ${t(
            'calendar_page.going'
          )}`}</div>
        )}
        {event.invited_count >= 1 && (
          <div className={styles.invited} onClick={() => setIsModalOpen(true)}>{`${event.invited_count} ${t(
            'calendar_page.invited'
          )}`}</div>
        )}
        {event.total_count >= 1 && (
          <div className={styles.total} onClick={() => setIsModalOpen(true)}>{`${event.total_count} ${t(
            'calendar_page.total'
          )}`}</div>
        )}
      </div>
      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          handleClose={() => setIsModalOpen(false)}
          title={`${dayjs(event.date).format('ddd')} ${dayjs(event.date).format('DD')} ${dayjs(event.date).format(
            'MMMM'
          )}`}
          customContentStyle={{
            width: isMobile ? '90%' : '60%',
            maxHeight: isMobile ? '90vh' : '80vh',
            justifyContent: 'unset'
          }}>
          {
            <div className={styles.invitationPopupContainer}>
              <div className={styles.innerPopupContainer}>
                {event.events &&
                  event.events.length >= 1 &&
                  event.events.map((m, i) => (
                    <MixrCard
                      key={m.mixr_id}
                      mixrId={m.mixr_id}
                      groupId={m.group_id}
                      picture={m.mix_picture}
                      startDate={m.event_utc_start_datetime}
                      endDate={m.event_utc_end_datetime}
                      utcOffset={m.event_utc_offset || '+00:00'}
                      timezone={m.timezone}
                      participants={m.number_of_participants}
                      url={m.mixr_url}
                      title={m.mixr_title}
                      name={m.group_title}
                      description={m.mixr_description}
                      color={m.is_over ? 'gray' : m.mixr_color ? m.mixr_color : appConstantSettings.DEFAULT_COLOR.name}
                      isRecurrence={m.recurrence_type === 'recurring' ? true : false}
                      attendance={m.mixr_attending_type}
                      userAttendance={m.user_attending_type}
                      isMixrOver={m.is_over}
                      layout='horizontal'
                      organizer={{ name: m.organizer_name }}
                      menuPortalTarget={true}
                      withGroupDetails={true}
                      withoutGroupApproval={m.without_group_approval}
                      isInvited={m.is_invited === 1}
                      groupRole={m.role_group}
                    />
                  ))}
              </div>
            </div>
          }
        </Modal>
      )}
    </React.Fragment>
  )
}
export default MonthlyEvent
